// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_SalesOrder_Price"
const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    { key: "id", label: "编号", sortable: true, thStyle: { width: "60px" } },
    { key: "SEI_InventTable_ItemId", label: "物料编号", sortable: true },
    { key: "AccountCode", label: "账户编码", sortable: true },
    { key: "Amount", label: "价格", sortable: true },
    { key: "PriceCost", label: "成本", sortable: true },
    { key: "CurrencyCode", label: "币种", sortable: true },
    { key: "QuantityAmountFrom", label: "数量(从)", sortable: true },
    { key: "QuantityAmountTo", label: "数量(到)", sortable: true },
    {
      key: "FromDate",
      label: "开始日期",
      sortable: true,
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      sortable: true,
      type: "date"
    },
    { key: "Description", label: "备注", sortable: true },
    { key: "is_approved", label: "审批", sortable: true, type: "boolean" }
  ],
  item_fields: [
    { key: "id", label: "编号", sortable: true, width: "60px" },
    { key: "SEI_InventTable_ItemId", label: "物料编号" },
    { key: "AccountCode", label: "账户编码", width: "80px" },
    { key: "Amount", label: "价格", editable: true, type: "number" },
    { key: "PriceCost", label: "成本", editable: true, type: "number" },
    { key: "CurrencyCode", label: "币种", editable: true },
    {
      key: "QuantityAmountFrom",
      label: "数量(从)",
      editable: true,
      type: "integer"
    },
    {
      key: "QuantityAmountTo",
      label: "数量(到)",
      editable: true,
      type: "integer"
    },
    { key: "FromDate", label: "开始日期", editable: true, type: "date" },
    { key: "ToDate", label: "结束日期", editable: true, type: "date" },
    { key: "Description", label: "备注", editable: true, type: "textarea" }
  ],
  inventTable_fields: [
    { key: "id", label: "编号", sortable: true, thStyle: { width: "60px" } },
    { key: "ItemId", label: "物料编号", sortable: true },
    { key: "NameAlias", label: "物料名称", sortable: true },
    { key: "TEC_CustAccount", label: "客户帐户", sortable: true },
    { key: "TEC_NetArea", label: "净面积", sortable: true },
    { key: "TEC_SpecType", label: "规格型号", sortable: true },
    { key: "TEC_Weight", label: "单位重量", sortable: true },
    { key: "inventUnitId", label: "单位", sortable: true },
    { key: "SEI_ItemGroupId", label: "物料组", sortable: true },
    { key: "SEI_Custname", label: "客户名称", sortable: true }
  ]
}

const dataForm = {
  id: "",
  SEI_InventTable_ItemId: "",
  AccountCode: "",
  Amount: "",
  PriceCost: "",
  CurrencyCode: "",
  QuantityAmountFrom: "",
  QuantityAmountTo: "",
  FromDate: "",
  ToDate: "",
  Description: ""
}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///save
  async saveSalesQuoteItems(items) {
    let add_list = [],
      update_list = []
    _.each(items, t => {
      if (_.isInteger(t.id)) {
        update_list.push(t)
      } else {
        let _t = _.cloneDeep(t)
        delete _t.id
        add_list.push(_t)
      }
    })

    let _actions = []
    if (add_list.length > 0) {
      _.each(add_list, t => {
        _actions.push(
          biz_data
            .insertAction({
              params: t,
              fields: _.map(fields.default, "key")
            })
            .action({})
        )
      })
    }
    if (update_list.length > 0) {
      _.each(update_list, t => {
        _actions.push(
          biz_data
            .updateAction({
              params: t,
              fields: _.map(fields.default, "key")
            })
            .action({})
        )
      })
    }

    let result = await api.query_batch({ actions: _actions })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///del
  async deleteData(items) {
    let _actions = []
    _.each(items, t => {
      _actions.push(
        biz_data
          .deleteAction({
            params: { id: t.id }
          })
          .action({})
      )
    })
    let result = await api.query_batch({ actions: _actions })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  },
  ///approve
  async approveData(items) {
    let _actions = []
    _.each(items, t => {
      _actions.push(
        biz_data
          .approveAction({
            params: { id: t.id, is_approved: t.is_approved }
          })
          .action({})
      )
    })
    let result = await api.query_batch({ actions: _actions })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  }
}

export { biz_data, dataForm, fields, methods };

